import * as pdfjsLib from 'pdfjs-dist';

// Configure PDF.js worker
pdfjsLib.GlobalWorkerOptions.workerSrc = '/assets/pdf.worker.min.js';

export async function extractTextFromPDF(pdfUrl: string): Promise<string> {
  try {
    // Load the PDF document
    const loadingTask = pdfjsLib.getDocument({
      url: pdfUrl,
      cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/cmaps/',
      cMapPacked: true,
      disableWorker: false,
      isEvalSupported: true,
      useSystemFonts: true
    });
    
    const pdf = await loadingTask.promise;
    
    // Get all pages
    const maxPages = pdf.numPages;
    const pageTextPromises = [];
    
    // Extract text from each page
    for (let pageNum = 1; pageNum <= maxPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const textContent = await page.getTextContent();
      const pageText = textContent.items
        .map((item: any) => item.str)
        .join(' ');
      pageTextPromises.push(pageText);
    }
    
    // Combine all pages
    const fullText = (await Promise.all(pageTextPromises)).join('\n\n');
    
    return fullText;
  } catch (err) {
    console.error('Error extracting PDF text:', err);
    throw new Error('Failed to extract text from PDF');
  }
}